import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { User } from '@/api'

export const useAppStore = defineStore('app', () => {
  const isAuthenticated = ref(false)
  const user = ref<User | null>(null)

  function setAuthenticated(authenticated: boolean) {
    isAuthenticated.value = authenticated
  }

  function setUser(userData: User | null) {
    user.value = userData
  }

  return { isAuthenticated, user, setAuthenticated, setUser }
})
